// removed by extract-text-webpack-plugin
module.exports = {"label":"InformationSection__label___2N31p","value":"InformationSection__value___1QSiF"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/InformationSection.scss
// module id = 773
// module chunks = 0